import api from '../../../common/api.js'
import createCSVFile from '../../../common/createCSVFile.js'
import {getNounsFromValue} from '../../../common/tokenizeOptions.js'
import {isNumeric, isPresent} from '../../../common/utils.js'
import {useSelector} from '../../../store.js'
import {
  columnOptionsSelector,
  columnOptionsToHeaders,
  processFiles,
} from '../dataImportFunctions.js'
import Header from '../Header.js'

const TYPE = 'manage_kits'
const COLUMN_OPTIONS = [
  {value: 'sku', display: 'SKU', required: true, columnMap: /^sku/i},
  {
    value: 'add_sku',
    display: 'Add Child SKU',
    columnMap: /^(add|update|create).(child.)?sku$/i,
    error(state, {payload}) {
      if (!isPresent(payload.remove_sku) && !isPresent(payload.add_sku)) {
        return 'Add Child SKU is required'
      }
    },
  },
  {
    value: 'remove_sku',
    display: 'Remove Child SKU',
    columnMap: /^(remove|delete).(child.)?sku$/i,
  },
  {
    value: 'quantity',
    display: 'Quantity',
    columnMap: /quantity/i,
    error(state, {value, payload}) {
      if (!isPresent(payload.remove_sku) && !isNumeric(value)) {
        return 'Quantity must be a number'
      }
    },
  },
]

async function createExampleFile(columnOptions) {
  const {json: data} = await api.get('/product/', {limit: 10, kit: true})

  const headers = columnOptionsToHeaders(columnOptions)

  const rows = []

  for (const product of data.product) {
    for (const kitComponent of product.kit_components) {
      rows.push([product.sku, kitComponent.sku, '', kitComponent.quantity])
    }
  }

  createCSVFile(headers, rows, 'Manage_Kits-example.csv')
}

function KitImport({importOptions}) {
  const columnOptions = useSelector((state) =>
    columnOptionsSelector(state, {columnOptions: COLUMN_OPTIONS}),
  )

  return (
    <div>
      <Header
        importOptions={importOptions}
        processFiles={(files) => processFiles(columnOptions, files)}
        createExampleFile={() => createExampleFile(columnOptions)}
        columnOptions={columnOptions}
        type={TYPE}
      />
    </div>
  )
}

const option = {
  value: TYPE,
  display: 'Manage Kits',
  category: 'kits_boms',
  Component: KitImport,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
KitImport.option = option

export default KitImport
